import { Helmet } from 'react-helmet-async';

export default function Publications() {
  return (
    <div className="bg-gradient-to-b from-[#E6F7F4] to-[#C5E8E3] min-h-screen">
      <div className="max-w-7xl mx-auto px-8 py-16">
        <Helmet>
          <title>Publications | BIOCAP Website</title>
          <meta name="description" content="BIOCAP publications, papers, and reports on coastal infrastructure and marine ecosystem research." />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        </Helmet>
        <h1 className="text-4xl font-bold mb-8">Publications</h1>
      </div>
    </div>
  );
}
